var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.46 3.707a.65.65 0 0 1 0 .92L5.736 9.35h10.097a.65.65 0 1 1 0 1.3H5.736l4.724 4.724a.65.65 0 1 1-.92.919L3.707 10.46a.65.65 0 0 1 0-.92L9.54 3.707a.65.65 0 0 1 .92 0Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40NTk2IDMuNzA3MDVDMTAuNzEzNSAzLjk2MDg5IDEwLjcxMzUgNC4zNzI0NSAxMC40NTk2IDQuNjI2MjlMNS43MzU5IDkuMzVIMTUuODMzM0MxNi4xOTIzIDkuMzUgMTYuNDgzMyA5LjY0MTAyIDE2LjQ4MzMgMTBDMTYuNDgzMyAxMC4zNTkgMTYuMTkyMyAxMC42NSAxNS44MzMzIDEwLjY1SDUuNzM1OUwxMC40NTk2IDE1LjM3MzdDMTAuNzEzNSAxNS42Mjc2IDEwLjcxMzUgMTYuMDM5MSAxMC40NTk2IDE2LjI5M0MxMC4yMDU4IDE2LjU0NjggOS43OTQyMiAxNi41NDY4IDkuNTQwMzggMTYuMjkzTDMuNzA3MDQgMTAuNDU5NkMzLjQ1MzIgMTAuMjA1OCAzLjQ1MzIgOS43OTQyMiAzLjcwNzA0IDkuNTQwMzhMOS41NDAzOCAzLjcwNzA1QzkuNzk0MjIgMy40NTMyMSAxMC4yMDU4IDMuNDUzMjEgMTAuNDU5NiAzLjcwNzA1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";